import * as _ from 'lodash';
import createSelector from 'selectorator';

const getLicenses = createSelector(['licenses.licenses']);

export default {
  getLicenseList: createSelector([getLicenses], _.values),
  getStatus: createSelector(['licenses.status']),
};
